import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-delegasi-riwayat-detail-modal',
  templateUrl: './delegasi-riwayat-detail-modal.component.html',
  styleUrls: ['./delegasi-riwayat-detail-modal.component.scss'],
})
export class DelegasiRiwayatDetailModalComponent implements OnInit {
  data: any = {};
  members: any[] = [];

  constructor(
    private navParams: NavParams,
    private modalController: ModalController
  ) {
    this.data = this.navParams.data?.data || {};
    this.members = Array.isArray(this.data?.members) ? this.data.members : [];
  }

  ngOnInit(): void {}

  close() {
    this.modalController.dismiss();
  }
}
